import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

import GradingConfigurations from "LearningCourse/routes/CourseSettings/routes/GradingConfigurations";
import GradingVisibility from "LearningCourse/routes/CourseSettings/routes/GradingVisibility";
import MYPCriteriaConfigurationWrapper from "./routes/MYPCriteriaConfigurationWrapper";

export default store => ({
  path: ":subjectId",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "subject-settings" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;
      return component;
    })
  ),
  childRoutes: [
    GradingConfigurations(store),
    GradingVisibility(store),
    MYPCriteriaConfigurationWrapper(store),
  ],
});
